"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryConfirmation = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/inventory/modules/inventory-detail/store");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./inventory-confirmation.less");
let InventoryConfirmation = class InventoryConfirmation extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleAddLater = () => {
            const inventoryId = this.props.params[0];
            router_1.RouteManager.transitionTo(`/formulary/0/${inventoryId}`);
        };
        this.handleAddNow = () => {
            const inventoryId = this.props.params[0];
            router_1.RouteManager.transitionTo(`/formulary/0/${inventoryId}/pharmacies`);
        };
    }
    componentWillMount() {
        console.log("this.props.params is ", this.props.params);
        const inventoryId = Number(this.props.params[0]);
        if (inventoryId) {
            store_1.inventoryDetailStore.readInventory(inventoryId);
        }
    }
    render() {
        return (React.createElement("div", { className: "inventory-confirmation" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Success" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement(ui_1.UiForm, { buttons: [
                        React.createElement(ui_1.UiButton, { onClick: this.handleAddLater }, "Add to pharmacies Later"),
                        "Add to pharmacies now"
                    ], onSubmit: this.handleAddNow, title: `${store_1.inventoryDetailStore.name} successfully added!` },
                    React.createElement("div", { className: "inventory-confirmation__message" },
                        "If you would like to make ",
                        store_1.inventoryDetailStore.name,
                        " available to any of your pharmacies, you must add it to each of their inventories, would you like to do that now?")))));
    }
};
InventoryConfirmation = __decorate([
    mobx_react_1.observer
], InventoryConfirmation);
exports.InventoryConfirmation = InventoryConfirmation;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-confirmation/inventory-confirmation.tsx
// module id = 3456
// module chunks = 0